import Link from 'next/link';
import { forwardRef } from 'react';
import ImageWithFallback from '../common/image-with-fallback';

const TravelCard = forwardRef<HTMLAnchorElement, { imageUrl: string; name: string; engName: string; id: string }>(
  ({ imageUrl, name, engName, id }, ref) => {
    return (
      <Link
        ref={ref}
        href={`/travelCard/${id}`}
        scroll={false}
        prefetch={false}
        className='flex flex-col gap-6pxr relative hover-upside'
      >
        <div className='absolute top-0 left-0 w-full aspect-[154/100] rounded-6pxr bg-black/30 flex items-center justify-center'>
          <p className='sub-title-14-bold text-white'>{engName}</p>
        </div>
        <ImageWithFallback
          src={imageUrl}
          alt={name}
          className='w-full aspect-[154/100] rounded-6pxr object-cover'
          width={154}
          height={100}
          fallbackSrc='https://hoolzzuk-public-images.s3.ap-northeast-2.amazonaws.com/cities/square_128x128.png'
        />
        <div className='w-full overflow-hidden text-left text-new-gray-900 h-20pxr text-ellipsis body-14-md'>
          {name}
        </div>
      </Link>
    );
  },
);
TravelCard.displayName = 'TravelCard';

export default TravelCard;
